import { gql as contentfulGql } from '@apollo/client'
import { GetTheatricalLandingPageNewQuery, GetTheatricalLandingPageOldQuery } from '@/types/codegen-contentful'

export type TheatricalLandingReleaseOld =
  | NonNullable<NonNullable<NonNullable<GetTheatricalLandingPageOldQuery>['inTheaters']>['items']>[number]
  | NonNullable<NonNullable<NonNullable<GetTheatricalLandingPageOldQuery>['upcoming']>['items']>[number]
  | NonNullable<NonNullable<NonNullable<GetTheatricalLandingPageOldQuery>['pastReleases']>['items']>[number]

export type TheatricalLandingReleaseNew =
  | NonNullable<
      NonNullable<NonNullable<GetTheatricalLandingPageNewQuery>['theatricalLandingReleaseCollection']>['items']
    >[number]

export const GET_THEATRICAL_LANDING_PAGE_OLD = contentfulGql/* GraphQL */ `
  query getTheatricalLandingPageOld($preview: Boolean!) {
    banners: ultrawideBannerCollection(
      preview: $preview
      limit: 1
      where: { locations_contains_some: ["tickets-landing"] }
    ) {
      items {
        sys {
          id
        }
        backgroundImage
        mobileBackgroundImage
        tabletBackgroundImage
        altText
        logo {
          image
          title
          height
          width
        }
        description
        href
        guildHref
        logoStyle
        backgroundStyle
        gravity
      }
    }
    inTheaters: theatricalLandingReleaseCollection(
      preview: $preview
      limit: 10
      where: { releaseStatus_contains: "in-theaters" }
    ) {
      items {
        sys {
          id
        }
        toBeAnnounced
        releaseStatus
        linkUrl
        dateDisplayOption
        filmDetails {
          filmName
          mediumDescription
          moviePoster
          theatricalReleaseDate
          releaseYear
          trailerSourceUrl
        }
      }
    }
    upcoming: theatricalLandingReleaseCollection(
      preview: $preview
      limit: 10
      where: { releaseStatus_contains: "upcoming" }
    ) {
      items {
        sys {
          id
        }
        toBeAnnounced
        releaseStatus
        linkUrl
        dateDisplayOption
        filmDetails {
          filmName
          mediumDescription
          moviePoster
          theatricalReleaseDate
          releaseYear
          trailerSourceUrl
        }
      }
    }
    pastReleases: theatricalLandingReleaseCollection(
      preview: $preview
      limit: 10
      where: { releaseStatus_contains: "past-release" }
    ) {
      items {
        sys {
          id
        }
        toBeAnnounced
        releaseStatus
        linkUrl
        dateDisplayOption
        filmDetails {
          filmName
          mediumDescription
          moviePoster
          theatricalReleaseDate
          releaseYear
          trailerSourceUrl
        }
      }
    }
  }
`

export const GET_THEATRICAL_LANDING_PAGE_NEW = contentfulGql/* GraphQL */ `
  query getTheatricalLandingPageNew($preview: Boolean!) {
    theatricalLandingReleaseCollection(preview: $preview) {
      items {
        sys {
          id
        }
        toBeAnnounced
        releaseStatus
        linkUrl
        dateDisplayOption
        imagesCollection {
          items {
            item
          }
        }
        contentCatalogId
        filmDetails {
          filmName
          mediumDescription
          moviePoster
          theatricalReleaseDate
          releaseYear
          trailerSourceUrl
        }
      }
    }
  }
`

/**
 * Note: The "angel-studios" project is the "general"/"no project" project.
 */
export const GET_TICKETS_PAGE_FAQS = contentfulGql/* GraphQL */ `
  query getTicketsPageFaq($locale: String, $preview: Boolean) {
    faqCollection(
      where: { AND: [{ location: "ticket" }, { project: { slug: "angel-studios" } }] }
      locale: $locale
      preview: $preview
      order: ordinal_ASC
    ) {
      items {
        answer {
          json
        }
        ordinal
        question
        sys {
          id
        }
      }
    }
  }
`
